import { useRef } from "react"

type Opts = { onLeft?: () => void; onRight?: () => void; threshold?: number }

export function useSwipe({ onLeft, onRight, threshold = 50 }: Opts) {
  const start = useRef<{ x: number; y: number } | null>(null)

  return {
    onTouchStart: (e: React.TouchEvent) => {
      const t = e.touches[0]
      start.current = { x: t.clientX, y: t.clientY }
    },
    onTouchEnd: (e: React.TouchEvent) => {
      if (!start.current) return
      const t = e.changedTouches[0]
      const dx = t.clientX - start.current.x
      const dy = t.clientY - start.current.y
      start.current = null
      if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy)) return
      if (dx < 0) onLeft?.()
      else onRight?.()
    },
  }
}
